import { usePermissionsForInstitutions } from '@/hooks/usePermissionsForInstitutions'
import { permissionTypes } from '@/enums/permissionTypes'
import { usePermissionChecker } from './usePermissionChecker'
import context from '@/context'

export function useInstitutionPermissionChecker (institutionId, isChangeItemId) {
  const { institutionEdit, institutionReadOnly } = usePermissionsForInstitutions([institutionId], isChangeItemId)
  const isGranted = usePermissionChecker()

  return function getInstitutionPermission (permissionNumber) {
    if (context.isReportApp() && isGranted('CanViewInstitutions')) {
      return permissionTypes.enum.Edit
    }

    if (institutionEdit & permissionNumber) {
      return permissionTypes.enum.Edit
    }

    if (institutionReadOnly & permissionNumber) {
      return permissionTypes.enum.ReadOnly
    }

    return permissionTypes.enum.None
  }
}



// WEBPACK FOOTER //
// ./src/hooks/useInstitutionPermissionsChecker.js